import { render, staticRenderFns } from "./Accesses.vue?vue&type=template&id=aec9feea&scoped=true&"
import script from "./Accesses.vue?vue&type=script&lang=js&"
export * from "./Accesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec9feea",
  null
  
)

export default component.exports